module.exports = __webpack_public_path__ + "img/EmbolizationCalculation2.5c146e03.png";